var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{staticClass:"sticky-bar",attrs:{"fixed-tabs":""},model:{value:(_vm.mobileTabs),callback:function ($$v) {_vm.mobileTabs=$$v},expression:"mobileTabs"}},[_c('v-tab',[_vm._v("\n        "+_vm._s(_vm.$t('info'))+"\n    ")]),_vm._v(" "),_c('v-tab',[_vm._v("\n        "+_vm._s(_vm.$t(_vm.mobileTab1Title))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }